import React, { Component } from 'react';

import { ListLayout } from '../containers/Layout';
import { TableRow, TableCell, Button, TableHead, TableBody, IconButton, Box, Grid } from '@material-ui/core';
import { DeleteRounded, AddRounded, EditRounded } from '@material-ui/icons';
import TableFooterPagination from '../../../../commonModules/interface/TableFooterPagination';
import { isEmpty, size } from 'lodash';
import Dialog from '../../../../commonModules/interface/Dialog';
import InputText from '../../../../commonModules/interface/form-input-inline';
import { Alert } from '@material-ui/lab';
import Currency from '../../../../commonModules/Currency';

class ListReappro extends Component{
    state = {
        openUpdateTransport: false,
        transport: 0,
        taxes: 0,
        updatedPurchase: {}
    }

    updateTransportForm = async (purchase) => {
        console.log('[INFO] change status', {purchase});

        this.setState({
            openUpdateTransport: true,
            updatedPurchase: purchase,
            transport: purchase.transport,
            taxes: purchase.taxes
        })
    }
    
    submitTransport = async () => {
        console.log('[INFO] change status');

        let p = Object.assign({}, this.state.updatedPurchase)
        p.transport = parseFloat(this.state.transport)
        p.taxes = parseFloat(this.state.taxes)
        
        this.props.changeStatus(p)
        // check err
        this.setState({ 
            openUpdateTransport: false,
            transport: 0,
            taxes: 0,
            updatedPurchase: {}
        })

    }

    createReapproList = (list) => {
        const { PURCHASES_REAPPRO, REAPPRO, SHOPS, STATE, rowsPerPage, currentPage } = this.props
        // return  this.props.pageOfItems.map( ID => { 
        return list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map(reappro => {
               
            if(reappro){
                const shopDest = SHOPS[reappro.shop_dest]
                const shop = SHOPS[reappro.shop_id]
                const match_purchase = PURCHASES_REAPPRO[reappro.reappro_purchase_id]
                if (!shop){
                    console.log('====================================');
                    console.log({reappro});
                    console.log('====================================');
                }
                return (        
                    <TableRow key={reappro.id}>
                        {/* <TableCell>{reappro.id}</TableCell> */}
                        <TableCell>{(new Date(reappro.date)).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>
                            <a href="#" onClick={ ()=> this.props.handleSingleShop(shop) }> {shop && shop.name}</a>
                        </TableCell>
                        <TableCell>
                            <a href="#" onClick={ ()=>this.props.handleSingleShop(shopDest) }> {shopDest && shopDest.name}</a>
                        </TableCell>
                        <TableCell>
                            {reappro.comments}
                        </TableCell>
                        {match_purchase.received &&
                            <TableCell>Reçu</TableCell>
                        }
                                
                        {!match_purchase.received && 

                            <TableCell>
                                <Button 
                                    disabled={STATE.purchases.fetching}
                                    color="secondary"
                                    variant="contained" 
                                    onClick={() => this.updateTransportForm(match_purchase)}
                                >
                                    Valider Reception
                                </Button>
                            </TableCell>
                        }
                        <TableCell><Currency value={Math.round(match_purchase.prix_revient)} /></TableCell>
                        <TableCell>
                            <IconButton 
                                color="secondary" 
                                onClick={() => this.props.handleSingleSale(reappro, shop, shopDest)}
                            >
                                <AddRounded />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                            <IconButton  
                                onClick={()=> this.props.handleDelete(reappro)  }
                            >
                                <DeleteRounded  color="error" />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                )

            }
        })
    }
    createReapproDraftList = (list) => {
        const { SHOPS, STATE, rowsPerPage, currentPage } = this.props
        // return  this.props.pageOfItems.map( ID => { 
        return list.slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage).map(reappro => {
            if(reappro){
                const shopDest = SHOPS[reappro.shop_dest]
                const shop = SHOPS[reappro.shop_id]
                if (!shop){
                    console.log('====================================');
                    console.log({reappro});
                    console.log('====================================');
                }
                return (        
                    <TableRow key={reappro.id}>
                        {/* <TableCell>{reappro.id}</TableCell> */}
                        <TableCell>{(new Date(reappro.date)).toLocaleString('fr-FR')}</TableCell>
                        <TableCell>
                            <a href="#" onClick={ ()=> this.props.handleSingleShop(shop) }> {shop && shop.name}</a>
                        </TableCell>
                        <TableCell>
                            <a href="#" onClick={ ()=>this.props.handleSingleShop(shopDest) }> {shopDest && shopDest.name}</a>
                        </TableCell>
                        <TableCell>
                            {reappro.comments}
                        </TableCell>
                        <TableCell>
                            <IconButton 
                                color="secondary" 
                                onClick={() => this.props.handleSingleSale(reappro, shop, shopDest)}
                            >
                                <AddRounded />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                            <IconButton 
                                color="secondary" 
                                onClick={() => this.props.handleUpdate(reappro)}
                            >
                                <EditRounded />
                            </IconButton>
                        </TableCell>
                        <TableCell>
                            <IconButton  
                                onClick={()=> this.props.handleDelete(reappro)}
                            >
                                <DeleteRounded  color="error" />
                            </IconButton>
                        </TableCell>
                    </TableRow>
                )

            }
        })
    }

    displayList = () => {
        // const { REAPPRO } = this.props;
        let listAll = []
        let tab = []
        let rows = 0
        // if (!isEmpty(REAPPRO)){
            let filteredList = this.props.getFilteredList()
            // listAll = filteredList
            rows = size(filteredList)
            tab = this.props.draft ? this.createReapproDraftList(filteredList) : this.createReapproList(filteredList)
            listAll = filteredList.map(sale => sale.id)
        // }
        return { tab, size:rows, listAll}
    }  
    render(){
        const { openUpdateTransport } = this.state;
        let list = this.displayList()
        return(
            <Box>

            {openUpdateTransport &&
                <Dialog
                    open={true}
                    title="Validation coût réel du transport"
                    submitAction={this.submitTransport}
                    close={ () => this.setState({ 
                        openUpdateTransport: false,
                        transport: 0,
                        taxes: 0,
                        updatedPurchase: {}
                    }) }
                    maxWidth="xs"
                >
                    <Box p={1}>
                        <InputText
                            label="Transport"
                            value={this.state.transport}
                            type="number"
                            onChange={(e) => this.setState({ transport: e.target.value})}
                        />
                        <InputText
                            label="Taxes"
                            value={this.state.taxes}
                            type="number"
                            onChange={(e) => this.setState({ taxes: e.target.value})}
                        />
                    </Box>
                    <Alert severity="warning">
                        Après validation vous ne pourrez plus modifier cette info
                    </Alert>
                </Dialog>
            }

                <ListLayout>
                    <TableHead>
                        <TableRow>
                            {/* <TableCell>ID</TableCell> */}
                            <TableCell>Date</TableCell>
                            <TableCell>Shop</TableCell>
                            <TableCell>Destination</TableCell>
                            <TableCell>Remarques</TableCell>
                            {!this.props.draft &&
                            <>
                                <TableCell>Statut</TableCell>
                                <TableCell>Total</TableCell>
                            </>
                            }
                            <TableCell>Détails</TableCell>
                            {this.props.draft &&
                                <TableCell>Modifier</TableCell>
                            }
                            <TableCell>Options</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        { list.size > 0 && 
                            list.tab
                        }
                        { list.size === 0  && 
                        <TableRow>
                            <TableCell colSpan="8">
                                <div className="text-center">
                                    <h5>Pas de Reapprovisionnement pour le moment</h5> 
                                    Cliquez sur <b className="onglet">"Nouveau"</b> Pour en créer un
                                </div>
                            </TableCell>
                        </TableRow>
                        }
                    </TableBody>
                    { list.size > 20  && 
                        <TableFooterPagination
                            colSpan={8}
                            count={list.size} 
                            // items={this.props.filteredList} 
                            onChangePage={this.props.onChangePage} 
                            initialPage={this.props.currentPage} 
                        />
                    }
                </ListLayout>                                             
            </Box>
        )
    }
}



export default ListReappro